import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    topSidebar: {
        display: 'flex',
        justifyContent: 'space-between'
    }
}